import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'

import "./checkboxList"
import "./filter"
import "./funds/tableColumnMove"
import "./admin/mutiple_checkbox"
window.Alpine = Alpine

Alpine.plugin(collapse)
Alpine.plugin(intersect)
Alpine.plugin(persist)

Alpine.start()
